export default {
   /// <summary>
   /// Chờ xử lý
   /// </summary>
   Waiting: 1,
   /// <summary>
   /// đã nâng cấp
   /// </summary>
   Updated: 2,

   /// <summary>
   /// đCập nhật
   /// </summary>
   Synced: 3,

   /// <summary>
   /// ĐÃ đông fbooj
   /// </summary>
   Success: 4,
}